import { useEffect, useState } from 'react';

export const useSwipe = (targetRef: React.RefObject<HTMLElement>, handler: () => void) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });

  const handleTouchStart = (e: TouchEvent) => {
    setStartPosition({ x: e.touches[0].clientX, y: e.touches[0].clientY });
    setPosition({ x: 0, y: 0 });
  };

  const handleTouchMove = (e: TouchEvent) => {
    setPosition({
      x: startPosition.x - e.touches[0].clientX,
      y: startPosition.y - e.touches[0].clientY,
    });
  };

  const handleTouchEnd = () => {
    if (Math.abs(position.x) > 50 || Math.abs(position.y) > 50) {
      handler();
    }

    setPosition({ x: 0, y: 0 });
    setStartPosition({ x: 0, y: 0 });
  };

  useEffect(() => {
    const target = targetRef.current;
    if (!target) {
      return;
    }

    target.addEventListener('touchstart', handleTouchStart);
    target.addEventListener('touchmove', handleTouchMove);
    target.addEventListener('touchend', handleTouchEnd);

    return () => {
      target.removeEventListener('touchstart', handleTouchStart);
      target.removeEventListener('touchmove', handleTouchMove);
      target.removeEventListener('touchend', handleTouchEnd);
    };
  });

  return { position };
};
